import React from 'react';
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import footerLogo from '../../Asset/img/bluspace.png';
const Footer = ({ myAdmin }) => {
  const navigate = useNavigate();
  return (
    <>
      <FooterWrapper>
        <div className="first footer-item">
          <div className="footer-logo">
            <img src={footerLogo} alt="our logo black" />
          </div>
          <div className="socials">
            <FaFacebook className="f-ico" />
            <FaInstagram className="f-ico" />
            <FaTwitter className="f-ico" />
            <FaLinkedin className="f-ico" />
          </div>
        </div>
        <div className="footer-item">
          <h2>Company</h2>
          <div className="list">
            <p
              onClick={() => {
                navigate('/faqs');
              }}>
              FAQs
            </p>
            <p
              onClick={() => {
                navigate('/career');
              }}>
              Career
            </p>
            <p
              onClick={() => {
                navigate('/legal-info');
              }}>
              Legal Info
            </p>
            <p
              onClick={() => {
                navigate('/policies');
              }}>
              Policies
            </p>
          </div>
        </div>
        <div className="footer-item">
          <h2>Quick Links</h2>
          <div className="list">
            <p
              onClick={() => {
                navigate('/about-us');
              }}>
              About Us
            </p>
            <p
              onClick={() => {
                navigate('/blogs');
              }}>
              Blue Blogs
            </p>
            <p
              onClick={() => {
                navigate('/contact');
              }}>
              Consultancy
            </p>
            <p
              onClick={() => {
                navigate('/services');
              }}>
              Our Offers
            </p>
          </div>
        </div>
        <div className="footer-item">
          <h2>Get In Touch</h2>
          <div className="list">
            <p>(233) 204 378 020</p>
            <p>Email _Bluspace</p>
            <p>WhatsApp _Blue</p>
            <p>Digital Address</p>
          </div>
        </div>
      </FooterWrapper>
      <FootCopy className="copy">
        <p>&copy; 2023 | All Copyright Reserved</p>
        <span
          onDoubleClick={() => {
            navigate('/auth');
            myAdmin(true);
          }}>
          || <small>Stay Safe</small>
        </span>
      </FootCopy>
    </>
  );
};

const FooterWrapper = styled.footer`
  background: var(--main-color);
  min-height: 40vh;
  padding: 50px 20px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;

  .first {
    transform: translateY(-1.5rem);
  }

  .footer-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    .list {
      display: flex;
      justify-content: flex-end;
      flex-direction: column;
      p {
        padding: 10px 0;
        cursor: pointer;
        font-size: 1.03rem;
        font-weight: 600;
        transition: all 600ms ease-in-out;

        &:hover {
          color: var(--bg-color);
        }
      }
    }
    .footer-logo {
      width: 50%;
      height: 60%;
      padding-bottom: 15px;
      img {
        width: 100%;
      }
    }

    .c-txt {
      padding-bottom: 15px;
    }

    .socials {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      .f-ico {
        width: 40px;
        height: 40px;
        background: var(--bg-color);
        border-radius: 5px;
        box-shadow: 0 0.5rem 10px var(--bga-color);
        color: var(--main-color);
        cursor: pointer;
        padding: 8px;
        transition: all 600ms ease-in-out;

        &:hover {
          box-shadow: none;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    .first {
      transform: translateY(-3rem);
    }
  }

  @media screen and (max-width: 430px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const FootCopy = styled.div`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  p,
  span {
    font-weight: 700;
  }

  @media screen and (max-width: 430px) {
    justify-content: center;
    padding-top: 15px;
    span {
      display: none;
    }
  }
`;

export default Footer;
